<template>
  <div>
    <div class="card mb-5 mb-xl-10">
      <BlockUI :loading="block" />
      <!-- <BlockUI :loading="true" /> -->
      <div class="card-body pt-9 pb-0">
        <!--begin::Details-->
        <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
          <!--begin::Info-->
          <div class="flex-grow-1">
            <!--begin::Title-->
            <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
              <!--begin::User-->
              <div class="d-flex flex-column">
                <!--begin::Name-->
                <div class="d-flex align-items-center mb-2">
                  <a class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
                    >{{ project.name }}
                  </a>
                  <a>
                    <span
                      :class="`${
                        project.published === true
                          ? 'svg-icon svg-icon-1 svg-icon-primary'
                          : ''
                      }`"
                      :title="
                        project.published === true
                          ? translate('Active')
                          : translate('Passive')
                      "
                    >
                      <inline-svg
                        :src="`${
                          project.published === true
                            ? 'media/icons/duotune/general/gen026.svg'
                            : 'media/icons/duotune/general/not-active.svg'
                        }`"
                      />
                    </span>
                  </a>

                  <a
                    @click="changePublished(project.published)"
                    :class="`btn btn-sm fw-bolder ms-2 fs-8 py-1 px-3 ${
                      project.published === false
                        ? 'btn-light-primary'
                        : 'btn-light-danger'
                    }`"
                    >{{
                      project.published === false
                        ? translate("Activate")
                        : translate("Deactivate")
                    }}</a
                  >
                </div>
                <!--end::Name-->

                <!--begin::Info-->
              </div>

              <div class="d-flex">
                <div
                  class="btn btn-icon btn-sm btn-active-light border"
                  :title="translate('question_component_button_backto_list')"
                  @click="router.push({ name: 'admin-projects' })"
                >
                  <span class="svg-icon svg-icon-2">
                    <inline-svg src="media/icons/duotune/arrows/arr077.svg" />
                  </span>
                </div>
              </div>
            </div>
            <!--end::Title-->
          </div>
          <!--end::Info-->
        </div>
        <!--end::Details-->

        <!--begin::Navs-->
        <div
          class="d-flex h-55px"
          style="overflow-x: auto; overflow-y: hidden"
        >
          <ul
            class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-6 flex-nowrap"
          >
            <!--begin::Nav item-->
            <li
              v-for="(item, index) in tabs"
              :key="index"
              class="nav-item"
            >
              <a
                :class="`nav-link me-6 ${
                  tab === item.name ? 'active langue-tabs-bold' : ''
                } `"
                style="cursor: pointer"
                @click="changeTab(item)"
              >
                {{ translate(item.name) }}
              </a>
            </li>
            <!--end::Nav item-->
          </ul>
        </div>
        <!--begin::Navs-->
      </div>
    </div>
    <transition
      name="component-fade"
      mode="out-in"
    >
      <keep-alive>
        <component :is="showComponent"> </component>
      </keep-alive>
    </transition>
  </div>
</template>

<script setup>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { reactive, ref, provide, shallowRef, onUnmounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import ProjectModule from "@/store/modules/Customer/ProjectModule";

// Multi Language
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const router = useRouter();
const store = useStore();

const block = ref(true);
const route = useRoute();
const Id = route.params.id;
provide("projectId", Id);
const project = reactive({
  id: null,
  name: null,
  customerId: null,
  customerName: null,
  published: true,
  locales: [],
});

ProjectModule.actions
  .GET_PROJECT(null, Id)
  .then((response) => {
    project.id = response.Id;
    project.name = response.Name;
    project.customerId = response.CustomerId;
    project.customerName = response.CustomerName;
    project.published = response.Published;
    project.locales = response.Locales;
    setCurrentPageBreadcrumbs(project.name, [translate("Projects")]);
  })
  .finally(() => {
    block.value = false;
  });

watch(locale, () => {
  setCurrentPageBreadcrumbs(project.name, [translate("Projects")]);
});

const tabs = ref([
  { name: "Details" },
  { name: "Locations" },
  { name: "Users" },
  { name: "CheckList" },
  { name: "AchievementLevels" },
]);

const showComponent = shallowRef();
const tab = ref("Details");

const changeTab = (item) => {
  tab.value = item.name;

  if (item.name !== "") {
    import(
      "@/components/Admin/Customer-Modal/ProjectDetail/P-" + item.name + "Comp.vue"
    ).then((value) => {
      showComponent.value = value.default;
    });
  }
};

const changePublished = () => {
  project.published = !project.published;
  store.dispatch("ProjectModule/UPDATE_PROJECT", project).then((response) => {
    if (!response) {
      project.published = !project.published;
    }
  });
};

changeTab({ name: "Details" });
provide("projectId", Id);
provide("project", project);

onUnmounted(() => {
  store.state.ProjectModule.locationList = [];
  store.state.ProjectModule.locationRecords = 0;
  store.state.ProjectModule.userList = [];
  store.state.ProjectModule.userRecords = 0;
});
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter-from,
.component-fade-leave-to {
  opacity: 0;
}
</style>
